/**
 * Common component loader methods used when building menu navigation
 * referenced server side in com.foretees.api.records.vueApp.enums.AppComponent
 */

import {MenuIndexLoader, ClubSettingsListLoader, EmptyLoader, LegacyIframe} from '@/ft-vue-core'
import {lazyLoading} from './lazyLoader'

export default {
  // Common
  Empty: EmptyLoader,
  MenuIndex: MenuIndexLoader,
  ClubSettingsList: ClubSettingsListLoader,
  StaffList: lazyLoading('configuration/staff/StaffList'),
  TerminalGroupList: lazyLoading('configuration/terminals/TerminalGroupList'),
  TerminalList: lazyLoading('configuration/terminals/TerminalList'),
  LegacyIframe: LegacyIframe,

  // Dining
  DiningDashboard: lazyLoading('dashboard/DiningDashboard'),
  ReservationsList: lazyLoading('reservations/ReservationsList'),
  EventsList: lazyLoading('events/EventsList'),
  EventGroupsList: lazyLoading('events/EventGroupsList'),
  EventGroupsItem: lazyLoading('events/EventGroupsItem'),
  EventBillingList: lazyLoading('events/EventBillingList'),
  EventBillingItem: lazyLoading('events/EventBillingItem'),
  BlockersReport: lazyLoading('reports/blockers/BlockersReport'),
  CancellationsReport: lazyLoading('reports/cancellations/CancellationsReport'),
  ConfirmationsReport: lazyLoading('reports/confirmations/ConfirmationsReport'),
  DiningReport: lazyLoading('reports/dining/DiningReport'),
  EventsReport: lazyLoading('reports/events/EventsReport'),
  KitchensList: lazyLoading('configuration/kitchens/KitchensList'),
  LocationsList: lazyLoading('configuration/locations/LocationsList'),
  MealPeriodsList: lazyLoading('configuration/mealPeriods/MealPeriodsList'),
  BlockersList: lazyLoading('configuration/blockers/BlockersList'),
  EventTypesList: lazyLoading('configuration/eventTypes/EventTypesList'),
  EventCategoriesList: lazyLoading('configuration/eventCategories/EventCategoriesList'),
  DressCodesList: lazyLoading('configuration/dressCodes/DressCodesList'),
  MusicalStylesList: lazyLoading('configuration/musicalStyles/MusicalStylesList'),
  OccasionsList: lazyLoading('configuration/occasions/OccasionsList'),
  TableConfigurationList: lazyLoading('configuration/tables/TableConfigurationList'),
  Servers: lazyLoading('configuration/servers/ServerList'),
  FloorPlan: lazyLoading('floorPlan/FloorPlan'),
  MemberRestrictionList: lazyLoading('configuration/memberRestrictions/MemberRestrictionList'),

  // POS
  PosSalesAreaList: lazyLoading('pos/salesArea/PosSalesAreaList'),

}
